<template>
  <qx-card-form title="运费信息">
    <qx-custom-form
        :noSubBtn="true"
        ref="baseForm"
        :formData="baseForm"
        labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import {dealNumber} from '@qx/utils';
import {
  getEnumList,
} from 'api';
export default {
  data () {
    return {
      baseForm: {
        inline: true,
        settlementMethodOptions: [],
        form: [
          {
            label: '结算方式',
            value: 'settlementMethod',
            type: 'select',
            width: '240px',
            onChange: () => {
              this.handleLabelTypeChange();
            },
          },
          {
            label: '结算单价',
            value: 'settlementUnitPrice',
            type: 'input',
            width: '240px',
            unit: '元/吨',
            onInput: (settlementUnitPrice) => {
              this.$refs.baseForm.setVal('settlementUnitPrice', dealNumber(settlementUnitPrice, false));
            },
          },
          {
            label: '拉运货值',
            value: 'goodsUnitPrice',
            type: 'input',
            width: '240px',
            unit: '元/吨',
            onInput: (goodsUnitPrice) => {
              this.$refs.baseForm.setVal('goodsUnitPrice', dealNumber(goodsUnitPrice, false));
            },
          },
          {
            label: '货损扣重比例',
            value: 'deductionsScale',
            type: 'input',
            width: '240px',
            unit: '‰',
            onInput: (deductionsScale) => {
              this.$refs.baseForm.setVal('deductionsScale', dealNumber(deductionsScale, false));
            },
          },
        ],
        rules: {
          settlementMethod: [ // 结算方式
            { required: true, message: '请选择结算方式', trigger: 'submit' },
          ],
        },
      },
    };
  },
  methods: {
    async getOptions () {
      if (!this.baseForm.settlementMethodOptions.length) {
        const enumList = await getEnumList({
          codeType: 'SETTLEMENT_METHOD_TYPE',
        });
        this.baseForm.settlementMethodOptions = enumList[0];
        this.$refs.baseForm.setVal('settlementMethod', enumList[0][0].value);
      }
    },

    async cacheData () {
      const formData = await this.$refs.baseForm.getVal();
      return formData;
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
    init (data = {}) {
      this.getOptions();

      let settlementMethod = this.baseForm.settlementMethodOptions[0] ? this.baseForm.settlementMethodOptions[0].value : '0';
      if (data.settlementMethod !== undefined) {
        settlementMethod = String(data.settlementMethod);
      }
      const res = {
        settlementMethod: settlementMethod,
        settlementUnitPrice: data.settlementUnitPrice / 100,
        goodsUnitPrice: data.goodsUnitPrice / 100,
        deductionsScale: data.deductionsScale / 100,
      };
      this.$refs.baseForm.setVal('form', res);
    },
  },
};
</script>

<style scoped lang="scss">
.tip{
  margin-left: 16px;
  color: #999;
  span{
    color: #666;
    margin-right: 8px;
  }
}
</style>
